export default __webpack_public_path__ + "static/media/chest0.8efad8b0.png";